module.exports = __webpack_public_path__ + "static/4-1d6b7424653c4f5ea2281fb0c097f4b5.jpg";